import { BaseWebComponentDataProvider } from '../../../../../../framework/BaseWebComponentDataProvider';
import { Policy, PolicyCounters } from '@nirvana/shared/dtos/types/policies/common';

export class GzSearchablePolicyPanelBaseDataProvider extends BaseWebComponentDataProvider {
  async getPolicyById(policyId: string): Promise<Policy> {
    throw new Error('Not implemented');
  }

  async getCounters(policyId: string): Promise<PolicyCounters> {
    throw new Error('Not implemented');
  }

  async getDefaultPolicy(): Promise<Policy> {
    throw new Error('Not implemented');
  }

  async getSuggestedNewPolicyName(): Promise<string> {
    throw new Error('Not implemented');
  }

  async generateSuggestedCloneName(clonedPolicyName: string): Promise<string> {
    throw new Error('Not implemented');
  }
}
